import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../i18n/index.ts';

export function LanguageSwitch() {
  const { i18n, t } = useTranslation();
  return (
    <label className="flex items-center gap-2 text-xs text-muted">
      <span className="sr-only">{t('common.language')}</span>
      <select
        id="language"
        value={i18n.language}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        className="ui-select rounded-md border border-control-border bg-sheet py-1.5 pl-2.5 text-xs text-ink"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
